import api from "@helpers/api";
import { ProcurementCreateType } from "@type/procurements/procurement";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/procurements`;

const apiEndPointForAggregate = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/procurement-demands-aggregate`;

export const fetchProcurements = async (query: any) => {
  const res = await api.get(apiEndPoint, {
    params: query,
  });

  return res;
};

export const createProcurement = async (data: ProcurementCreateType) => {
  const res = await api.post(apiEndPoint, {
    ...data,
  });

  return res;
};

export const updateProcurement = async (
  id: number | string,
  data: ProcurementCreateType,
) => {
  const res = await api.put(`${apiEndPoint}/${id}`, {
    ...data,
  });

  return res;
};

export const fetchProcurementById = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

// to get products for selected demand table
export const fetchDemandedProducts = async (query: any) => {
  const res = await api.get(apiEndPointForAggregate, {
    params: query?.demandIds?.length ? query : { demandIds: "" },
    paramsSerializer: {
      indexes: null,
    },
  });

  return res;
};

// assign committee
export const assignCommittee = async (id: string, data: any) => {
  const res = await api.post(`${apiEndPoint}/${id}/assign-committee`, data);

  return res;
};

// send to store

export const sendToStore = async (id: string, data: any) => {
  const res = await api.post(`${apiEndPoint}/${id}/procurement-details`, data);

  return res;
};

// purchase done

export const purchaseDone = async (id: string, data: any) => {
  const res = await api.post(`${apiEndPoint}/${id}/purchase-details`, data);

  return res;
};

//employees for approving procurement
export const getEmployeesForProcurementApproval = async ({
  positionId,
  unitId,
}: {
  positionId?: number;
  unitId?: number;
}) => {
  const employeeEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/procurement/approval/employee`;

  const res = await api.get(`${employeeEndPoint}`, {
    params: {
      positionId,
      unitId,
    },
  });

  return res;
};
